import { ErrorHandler, Injectable } from '@angular/core';
import { InstanaService } from './services/instana.service';
import { environment } from '../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class InstanaErrorHandler implements ErrorHandler {
    constructor(private instana: InstanaService) {}

    public handleError(error: never) {
        if (environment.instana) {
            this.instana.reportError(error);
        } else {
            throw error;
        }
    }
}
